<template>
  <ocr-recognition :source="INTELLIGENT_DOCUMENT_SOURCE_4.code" />
</template>

<script>
import ocrRecognition from '@/views/cargo/v0/ToolAssistant/ocrRecognition'
import {
  INTELLIGENT_DOCUMENT_SOURCE_4
} from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'OcrRecognitionSI',
  components: { ocrRecognition },
  data() {
    return {
      INTELLIGENT_DOCUMENT_SOURCE_4
    }
  }
}
</script>

<style scoped>

</style>
